module.exports = __webpack_public_path__ + "img/credit-card-providers.77aa8f0.png";